import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@mui/material/Button";
import TitlePage from "../../Shared/TitlePage";
import { useNavigate } from "react-router-dom";

function SelectMenuPage(props) {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div>
      <TitlePage Text="What do you want to do?" backbutton={false} {...props} />
      <div className={classes.container}>
        <div className={classes.boxStyle}>
          <p className={classes.menuItem}>Create a new project linked to a specific registration point.</p>
          <Button
            className={classes.linkButton}
            onClick={() => {
              navigate("/create", { state: { from: "/" } });
            }}
            variant="contained"
          >
            Create a project
          </Button>
        </div>
        <div className={classes.boxStyle}>
          <p className={classes.menuItem}>View all your projects. (See results, reports,...)</p>
          <Button
            className={classes.linkButton}
            variant="contained"
            onClick={() => {
              navigate("/projectreportoverview", { state: { from: "/" } });
            }}
          >
            Project Overview
          </Button>
        </div>
        <div className={classes.boxStyle}>
          <p className={classes.menuItem}>View all your graphs</p>
          <Button
            className={classes.linkButton}
            variant="contained"
            onClick={() => {
              navigate("/graphs", { state: { from: "/" } });
            }}
          >
            Graph Overview
          </Button>
        </div>
        <div className={classes.boxStyle}>
          <p className={classes.menuItem}>View and manage all your measurements</p>
          <Button
            className={classes.linkButton}
            variant="contained"
            onClick={() => {
              navigate("/datamanagement", { state: { from: "/" } });
            }}
          >
            Data management
          </Button>
        </div>
        <div className={classes.boxStyle}>
          <p className={classes.menuItem}>View and manage all financial data</p>
          <Button
            className={classes.linkButton}
            variant="contained"
            onClick={() => {
              navigate("/financialcenter", { state: { from: "/" } });
            }}
          >
            Financial Center
          </Button>
        </div>
        {/* <div className={classes.boxStyle}>
                    <p className={classes.menuItem}>View an overview of all revenue and costs linked to your accounts</p>
                    <Button className={classes.linkButton} variant="contained" onClick={() => { navigate('/generalledgeraccount', { state: { from: '/' } }) }}>General ledger account</Button>
                </div> */}
        <div className={classes.boxStyle}>
          <p className={classes.menuItem}>Configuration</p>
          <Button
            className={classes.linkButton}
            variant="contained"
            onClick={() => {
              navigate("/configuration", { state: { from: "/" } });
            }}
          >
            Configuration
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SelectMenuPage;

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "16px",

    borderRadius: "8px",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "50%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "60%",
    },

    [theme.breakpoints.down("md")]: {
      maxWidth: "90%",
    },
    marginRight: "auto",
    marginLeft: "auto",
    marginTop: "148px",
  },

  boxStyle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#FFFFFF",
    borderRadius: "8px",

    padding: "16px",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },

  menuItem: {
    color: "#1D3557",
    margin: "0",

    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      width: "100% !important",
      marginBottom: "15px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "100% !important",
      fontSize: "1.2rem",
    },
  },

  linkButton: {
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
      minWidth: "100% !important",
      minHeight: "46.8px",
      height: "90%",
      padding: "10px",
      fontSize: "1rem",
    },

    [theme.breakpoints.up("lg")]: {
      width: "320px",
      minWidth: "320px",
      height: "40px",
      fontSize: "1.2rem",
    },
    [theme.breakpoints.down("lg")]: {
      width: "320px",
      minWidth: "320px",
      fontSize: "1.2rem",
    },

    background: "#C3996B !important",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
